import { ProjectEntity } from '@/shared/lib/db'
import { create } from 'zustand'

interface ProjectStore {
    project: ProjectEntity | null
    setProject: (project: ProjectEntity | null) => void
}

export const useProjectStore = create<ProjectStore>((set) => ({
    project: null,
    setProject: (project) => set({ project }),
}))
